<template>
  <div class="check-page">
    <!-- 顶部导航栏 -->
    <div class="header-bar">
      <div class="header-left" @click="onBack">
        <van-icon name="arrow-left" size="20" color="#333333" style="font-weight:600;" />
      </div>
      <div class="header-title">{{ pageTitle }}</div>
      <div class="header-right"></div>
    </div>
    
    <!-- 搜索操作栏 -->
    <div class="scan-bar" v-if="!isViewMode">
      <div class="scan-input">
        <div style="background:#FFFFFF;border-radius:8px;border:1px solid #E5E5E5;height:32px;display:flex;align-items:center;padding:0 12px;">
          <van-icon name="search" size="14" color="#999999" style="margin-right:6px;" />
          <input
            v-model="barcode"
            placeholder="请输入物料编码"
            @keyup.enter="onSearch"
            style="border:none;outline:none;background:transparent;flex:1;font-size:14px;color:#333333;height:100%;"
          />
        </div>
      </div>
      <div style="width:30px;height:30px;background:#1ECD84;border-radius:8px;display:flex;align-items:center;justify-content:center;cursor:pointer;" @click="onSearch">
        <van-icon name="search" size="16" color="#FFFFFF" />
      </div>
      <div style="width:40px;height:30px;background:#235EFF;border-radius:8px;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:14px;color:#FFFFFF;font-weight:500;" @click="onScan">
        扫码
      </div>
<!--      <div style="width:40px;height:30px;background:#FDC71C;border-radius:8px;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:14px;color:#333333;font-weight:500;" @click="onSelect">-->
<!--        选择-->
<!--      </div>-->
    </div>

    <!-- 盘点列表 -->
    <div class="check-list" :class="!isViewMode ? 'check-list-has-scan' : 'check-list-view-mode'">
      <div v-if="checkList.length === 0" class="empty-state">
      </div>
      <div v-else class="list-content">
        <div v-for="(item, index) in checkList" :key="item.MATNO || item.IDSEQ || index" class="check-item-card">
          <div class="item-header">
            <span class="item-no">{{ index + 1 }}</span>
            <span class="item-code">{{ item.MATNO }}</span>
            <MaterialLabelPrint
              :material="item"
              :warehouse-name="formData.STKNM"
              :copies-in-preview="true"
              :disabled="materialPrintBusy"
              @busy="materialPrintBusy = $event"
            />
            <van-icon 
              v-if="!isViewMode"
              name="cross" 
              size="14"
              color="#FF4000" 
              @click="handleDeleteItem(item, index)"
              style="cursor: pointer;"
            />
          </div>
          <div class="item-content">
            <div class="item-info">
              <div class="item-name">{{ item.MATNM }}</div>
              <div class="item-spec">{{ item.MATDESC }}</div>
            </div>
            <div class="item-quantity">
              <div class="quantity-row">
                <span class="quantity-label">库存数</span>
                <span class="quantity-value">{{ item.STKQTY || 0 }}</span>
              </div>
              <div class="quantity-row">
                <span class="quantity-label">盘点数</span>
                <van-field
                  v-model.number="item.NOQTY"
                  type="number"
                  class="quantity-input"
                  placeholder="输入数量"
                  min="0"
                  :disabled="isViewMode"
                  @input="handleQuantityInput(item)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部统计和操作栏 -->
    <div class="footer-bar">
      <div class="footer-stats">
        已盘点：<span class="stats-count">{{ checkList.length }}</span> 项
      </div>
      <div class="footer-actions" v-if="isViewMode && formData.STFG === 'N'">
        <van-button 
          class="footer-btn footer-btn-void" 
          @click="onVoid"
          type="danger"
        >
          作废
        </van-button>
      </div>
      <div class="footer-actions" v-if="!isViewMode && formData.STFG === 'N'">
        <van-button 
          class="footer-btn footer-btn-cancel" 
          @click="onCancel"
        >
          取消
        </van-button>
        <van-button 
          class="footer-btn footer-btn-submit" 
          @click="onSubmit"
          type="primary"
        >
          保存
        </van-button>
      </div>
    </div>

    <!-- 物料选择弹窗 -->
    <van-popup v-model="showSelectDialog" position="bottom" :style="{ height: '80%' }">
      <div class="select-dialog">
        <div class="dialog-header">
          <span class="dialog-title">选择物料</span>
          <van-icon name="cross" size="20" @click="showSelectDialog = false" />
        </div>
        <div class="dialog-search">
          <van-field
            v-model="materialSearch"
            placeholder="搜索物料编码或名称"
            @input="onMaterialSearch"
          >
            <template #left-icon>
              <van-icon name="search" />
            </template>
          </van-field>
        </div>
        <div class="dialog-list">
          <div
            v-for="item in filteredMaterials"
            :key="item.IDSEQ"
            class="material-item"
            @click="onSelectMaterial(item)"
          >
            <div class="material-code">{{ item.MATNO }}</div>
            <div class="material-name">{{ item.MATNM }}</div>
            <div class="material-spec">{{ item.MATDESC }}</div>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 盘点数量输入弹窗 -->
    <van-dialog
      v-model="showQuantityDialog"
      :title="currentMaterial.MATNO"
      show-cancel-button
      @confirm="onConfirmQuantity"
      @cancel="onCancelQuantity"
      class-name="quantity-dialog"
    >
      <div class="quantity-form">
        <div class="form-row">
          <span class="form-label">物料名称</span>
          <span class="form-value">{{ currentMaterial.MATNM }}</span>
        </div>
        <div class="form-row">
          <span class="form-label">物料规格</span>
          <span class="form-value">{{ currentMaterial.MATDESC }}</span>
        </div>
        <div class="form-row">
          <span class="form-label">库存数</span>
          <span class="form-value">{{ currentMaterial.STKQTY || 0 }}</span>
        </div>
        <div class="form-row form-row-input">
          <span class="form-label required">盘点数</span>
          <input
            v-model.number="inputQuantity"
            type="number"
            placeholder="请输入盘点数量"
            class="quantity-input"
            min="0"
          />
        </div>
      </div>
    </van-dialog>
    <ScanCode
        :visible.sync="showScan"
        @success="handleScan"
    />

    <!-- 日期选择器 -->
    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择盘点日期"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onDateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-popup>

    <!-- 仓库选择器 -->
    <van-popup v-model="showWarehousePicker" position="bottom">
      <van-picker
        title="选择盘点仓库"
        show-toolbar
        :columns="warehouseColumns"
        @confirm="onWarehouseConfirm"
        @cancel="showWarehousePicker = false"
      />
    </van-popup>

    <!-- 盘点类型选择器 -->
    <van-popup v-model="showCheckTypePicker" position="bottom">
      <van-picker
        title="选择盘点类型"
        show-toolbar
        :columns="checkTypeColumns"
        @confirm="onCheckTypeConfirm"
        @cancel="showCheckTypePicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import ScanCode from "@/components/common/ScanCode.vue";
import MaterialLabelPrint from '@/components/stockCheck/MaterialLabelPrint.vue';
import {getDate} from '@/api/tools';
import {getBaseData, getTabColOrData} from '@/api/user';
export default {
  components: {ScanCode, MaterialLabelPrint},
  name: 'StockCheck',
  data() {
    return {
      showScan: false,
      sku: "",
      checkInfo: {},
      barcode: '',
      checkList: [],
      materialPrintBusy: false,
      showSelectDialog: false,
      showQuantityDialog: false,
      materialList: [],
      filteredMaterials: [],
      materialSearch: '',
      currentMaterial: {},
      inputQuantity: '',
      v_username: this.$cookies.get('v_telno'),
      v_corpid: this.$cookies.get('v_corpid'),
      v_usernm: this.$cookies.get('v_usernm'),
      v_url: 'xuper_auth/getTableRecMany', //api请求路径
      showDatePicker: false,
      showWarehousePicker: false,
      showCheckTypePicker: false,
      currentDate: new Date(),
      minDate: new Date(2024, 1, 1),
      maxDate: new Date(2030, 11, 31),
      formData: {
        ICDTTM: '',
        STKNO: '',
        STKNM: '',
        OTHTY: '',
        OTHTYNM: '',
        RMK: '',
        ADDUSER: '',
        ADDDTTM: '',
        IDTY: 'CHECK',
        STFG: 'N',
        CORPID: ''
      },
      warehouseColumns: [],
      checkTypeColumns: [],
      checkListDel: [],
      pageMode: 'add', // add, edit, check, view
      isDirty: false // 是否有未保存的变动
    }
  },
  computed: {
    pageTitle() {
      const mode = this.$route.query.mode || 'add'
      const idno = this.$route.query.IDNO || ''
      
      if (mode === 'add') {
        return '新增盘点'
      } else if (mode === 'edit') {
        return `${idno} - 编辑`
      } else if (mode === 'check') {
        return idno ? `${idno} - 盘点` : '物料盘点'
      } else if (mode === 'view') {
        return `${idno} - 查看`
      }
      return '新增盘点'
    },
    isViewMode() {
      return this.$route.query.mode === 'view'
    },
    isEditMode() {
      return this.$route.query.mode === 'edit'
    },
    isCheckMode() {
      return this.$route.query.mode === 'check'
    }
  },
  mounted() {
    // 获取传递的盘点信息
    this.checkInfo = this.$route.query
    this.pageMode = this.$route.query.mode || 'add'
    
    // 初始化表单数据
    if (this.pageMode === 'add') {
      // 新增模式
      this.formData = {
        ICDTTM: '',
        STKNO: '',
        STKNM: '',
        OTHTY: '',
        OTHTYNM: '',
        RMK: '',
        ADDUSER: this.v_usernm,
        ADDDTTM: getDate('day'),
        IDTY: 'CHECK',
        STFG: 'N',
        CORPID: this.v_corpid
      }
    } else {
      // 编辑或查看模式，使用传递过来的数据
      this.formData = {
        ICDTTM: this.checkInfo.ICDTTM,
        STKNO: this.checkInfo.STKNO,
        STKNM: this.checkInfo.STKNM,
        OTHTY: this.checkInfo.OTHTY,
        OTHTYNM: this.checkInfo.OTHTYNM,
        RMK: this.checkInfo.RMK,
        ADDUSER: this.checkInfo.ADDUSER,
        ADDDTTM: this.checkInfo.ADDDTTM,
        IDTY: 'CHECK',
        STFG: this.checkInfo.STFG,
        CORPID: this.v_corpid,
        IDSEQ: this.checkInfo.IDSEQ,
        IDNO: this.checkInfo.IDNO 
      }
      this.getDtlList(this.checkInfo.IDSEQ)
    }
    
    this.loadComboData()
  },
  methods: {
    // 返回
    onBack() {
      if (this.isDirty && !this.isViewMode) {
        this.$dialog.confirm({
          title: '提示',
          message: '当前有未保存的盘点数据，请先保存或者放弃盘点。确定放弃盘点并退出吗？',
          confirmButtonText: '放弃盘点',
          cancelButtonText: '继续盘点'
        }).then(() => {
          this.isDirty = false
          this.$router.go(-1)
        }).catch(() => {})
      } else {
        this.$router.go(-1)
      }
    },
    //盘点明细
    getDtlList(idseq){
      this.dtlData=[]
      getTabColOrData(this.v_url,'v_IC_STKdtl','idseq',idseq,'','','','', '' ).then((res) => {
        this.checkList =res.result
      })

    },
    // 搜索物料
    onSearch() {
      if (!this.barcode) {
        this.$toast('请输入物料编码')
        return
      }
      
      this.$axios({
        method: 'post',
        url: 'xuper_auth/getBaseData',
        data: {
          p_table: 'V_IC_STKLOG',
          p_key: 'MATNO',
          p_value: this.barcode,
          p_key2: 'CORPID',
          p_value2: this.v_corpid,
        }
      }).then(res => {
        if (res.code === '200' && res.result && res.result.length > 0) {
          const material = res.result[0]
          // 找到物料，弹出数量输入对话框
          this.currentMaterial = {
            MATNO: material.MATNO,
            MATNM: material.MATNM,
            MATDESC: material.MATDESC || '',
            STKQTY: material.QTY || 0,
            IDSEQ: material.MAT_IDSEQ
          }
          // 检查是否已经在checkList中
          const existItem = this.checkList.find(item => item.IDSEQ === material.MAT_IDSEQ)
          this.inputQuantity = existItem ? existItem.NOQTY : ''
          this.showQuantityDialog = true
        } else {
          this.$toast('当前没有这个物料编码')
        }
      }).catch(err => {
        console.error('搜索物料失败', err)
        this.$toast('搜索失败，请重试')
      })
    },
    // 扫码
    onScan() {
      this.showScan = true
    },
    // 选择物料
    onSelect() {
      this.showSelectDialog = true
    },
    // 加载物料列表
    loadMaterials() {
      if (!this.formData.STKNO) {
        return
      }
      this.$axios({
        method: 'post',
        url: 'xuper_auth/getBaseData',
        data: {
          p_table: 'V_MAT_STK',
          p_key: 'STKNO',
          p_value: this.formData.STKNO
        }
      }).then(res => {
        if (res.code === '200') {
          this.materialList = res.result
          this.filteredMaterials = res.result
        }
      })
    },
    // 搜索物料
    onMaterialSearch() {
      if (!this.materialSearch) {
        this.filteredMaterials = this.materialList
        return
      }
      this.filteredMaterials = this.materialList.filter(item =>
        item.MATNO.includes(this.materialSearch) ||
        item.MATNM.includes(this.materialSearch)
      )
    },
    // 选择物料
    onSelectMaterial(item) {
      this.currentMaterial = item
      this.inputQuantity = ''
      this.showSelectDialog = false
      this.showQuantityDialog = true
    },
    // 确认数量
    onConfirmQuantity() {
      if (this.inputQuantity === '' || this.inputQuantity === null || this.inputQuantity === undefined) {
        this.$toast('请输入盘点数量')
        return
      }
      // 通过IDSEQ查找是否已存在
      const existIndex = this.checkList.findIndex(item => item.IDSEQ === this.currentMaterial.IDSEQ)
      if (existIndex > -1) {
        // 已存在，更新盘点数量
        this.checkList[existIndex].NOQTY = this.inputQuantity
        this.isDirty = true
        this.$toast.success('更新成功')
      } else {
        // 不存在，添加新记录到checkList
        this.checkList.push({
          MATNO: this.currentMaterial.MATNO,
          MATNM: this.currentMaterial.MATNM,
          MATDESC: this.currentMaterial.MATDESC,
          STKQTY: this.currentMaterial.STKQTY,
          NOQTY: this.inputQuantity,
          IDSEQ: this.currentMaterial.IDSEQ
        })
        this.isDirty = true
        this.$toast.success('添加成功')
      }
      this.barcode = ''
      this.showQuantityDialog = false
    },
    // 取消数量输入
    onCancelQuantity() {
      this.showQuantityDialog = false
    },
    // 取消盘点
    onCancel() {
      if (this.isDirty) {
        this.$dialog.confirm({
          title: '提示',
          message: '当前有未保存的盘点数据，请先保存或者放弃盘点。确定放弃盘点并退出吗？',
          confirmButtonText: '放弃盘点',
          cancelButtonText: '继续盘点'
        }).then(() => {
          this.isDirty = false
          this.$router.go(-1)
        }).catch(() => {})
      } else {
        this.$router.go(-1)
      }
    },
    handleScan(code) {
      console.log("扫码结果", code)
      // 扫码返回的是MAT_IDSEQ
      const matIdseq = code
      this.showScan = false
      
      if (!this.formData.STKNO) {
        this.$toast('请先选择盘点仓库')
        return
      }
      
      this.$axios({
        method: 'post',
        url: 'xuper_auth/getBaseData',
        data: {
          p_table: 'V_IC_STKLOG',
          p_key: 'MAT_IDSEQ',
          p_value: matIdseq,
          p_key2: 'CORPID',
          p_value2: this.v_corpid
        }
      }).then(res => {
        if (res.code === '200' && res.result && res.result.length > 0) {
          const material = res.result[0]
          // 找到物料，弹出数量输入对话框
          this.currentMaterial = {
            MATNO: material.MATNO,
            MATNM: material.MATNM,
            MATDESC: material.MATDESC || '',
            STKQTY: material.QTY || 0,
            IDSEQ: material.MAT_IDSEQ
          }
          // 检查是否已经在checkList中
          const existItem = this.checkList.find(item => item.IDSEQ === material.MAT_IDSEQ)
          this.inputQuantity = existItem ? existItem.NOQTY : ''
          this.showQuantityDialog = true
        } else {
          this.$toast('当前仓库没有这个物料编码')
        }
      }).catch(err => {
        console.error('扫码查询失败', err)
        this.$toast('扫码失败，请重试')
      })
    },
    // 提交盘点
    onSubmit() {
      // 验证表头必填项
      if (!this.formData.ICDTTM) {
        this.$toast('盘点日期不能为空')
        return
      }
      if (!this.formData.STKNO) {
        this.$toast('盘点仓库不能为空')
        return
      }
      if (!this.formData.OTHTY) {
        this.$toast('盘点类型不能为空')
        return
      }
      
      // 验证明细数据
      if (this.checkList.length === 0) {
        this.$toast('明细资料不能为空')
        return
      }
      
      // 验证明细中的盘点数量
      let hasEmptyQty = false
      console.log(' this.checkList', this.checkList)
      this.checkList.forEach(item => {
        if (!item.NOQTY && item.NOQTY !== 0) {
          hasEmptyQty = true
        }
      })
      
      if (hasEmptyQty) {
        this.$toast('明细资料中的盘点数量不能为空')
        return
      }
      
      this.$dialog.confirm({
        title: '提示',
        message: '确定要保存盘点吗？'
      }).then(() => {
        const saveDtl = (idseq_) => {
          this.checkList.forEach(item => {
            item.IDSEQ = idseq_
            item.ACTQTY = Number(item.NOQTY) - Number(item.STKQTY || 0)
          })
          this.$axios({
            method: 'post',
            url: 'xuper_auth/batDtlSave2',
            data: {
              p_json: JSON.stringify(this.checkList),
              p_table: 'IC_STKDTL',
              p_idseq: idseq_,
              p_action: 'S'
            }
          }).then(res2 => {
            if (res2.code === '200') {
              // 删除已标记删除的明细
              if (this.checkListDel.length > 0) {
                for (let k = 0; k < this.checkListDel.length; k++) {
                  this.$axios({
                    method: 'post',
                    url: 'xuper_auth/delTabRec',
                    data: {
                      p_key: 'idseq',
                      p_value: idseq_,
                      p_key2: 'lstseq',
                      p_value2: this.checkListDel[k].LSTSEQ,
                      p_table: 'IC_STKDTL'
                    }
                  })
                }
              }
              this.isDirty = false
              this.$toast.success('盘点保存成功')
              this.$router.go(-1)
            } else {
              this.$toast.fail(res2.result || '明细保存失败')
            }
          }).catch(err => {
            console.error('明细保存失败', err)
            this.$toast.fail('明细保存失败，请重试')
          })
        }

        // 如果已经有 IDSEQ（即先保存了单据），直接保存明细；否则先保存表头再保存明细（兼容老模式）
        if (this.formData.IDSEQ) {
          saveDtl(this.formData.IDSEQ)
        } else {
          // 先保存表头数据
          this.$axios({
            method: 'post',
            url: 'xuper_auth/formOneSave',
            data: {
              p_json: JSON.stringify(Object.assign(this.formData, { CORPID: this.v_corpid })),
              p_table: 'IC_STK',
              frmid: '96'
            }
          }).then(res => {
            if (res.code === '200') {
              const idseq_ = res.idseq || this.formData.IDSEQ
              if (!idseq_) {
                this.$toast.fail('盘点单 ID 缺失，无法保存明细')
                return
              }
              this.formData.IDSEQ = idseq_
              saveDtl(idseq_)
            } else {
              this.$toast.fail(res.result || '表头保存失败')
            }
          }).catch(err => {
            console.error('表头保存失败', err)
            this.$toast.fail('保存失败，请重试')
          })
        }
      }).catch(() => {})
    },
    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    // 日期选择确认
    onDateConfirm(value) {
      this.formData.ICDTTM = this.formatDate(value)
      this.showDatePicker = false
    },
    // 仓库选择确认
    onWarehouseConfirm(value) {
      this.formData.STKNM = value.text
      this.formData.STKNO = value.value
      this.showWarehousePicker = false
      // 仓库改变后重新加载物料
      this.loadMaterials()
    },
    // 盘点类型选择确认
    onCheckTypeConfirm(value) {
      this.formData.OTHTYNM = value.text
      this.formData.OTHTY = value.value
      this.showCheckTypePicker = false
    },
    // 加载下拉框数据
    loadComboData() {
      this.$axios({
        method: 'post',
        url: 'xuper_auth/getBaseData',
        data: {
          p_table: 'v_sys_form_fld',
          p_key: 'idseq',
          p_value: '96',
          p_cond: ' and lstseq in (1,2)',
          p_key2: 'edcss',
          p_value2: 'select'
        }
      }).then(res => {
        if (res.result.length > 0) {
          for (let k = 0; k < res.result.length; k++) {
            getBaseData(
              'xuper_auth/getBaseData',
              'parentno',
              res.result[k].COMBO,
              '',
              '',
              'v_sys_base',
              ''
            ).then(res2 => {
              // 处理仓库下拉数据
              if (res.result[k].FLDNO === 'STKNO') {
                this.warehouseColumns = res2.result.map(item => ({
                  text: item.CNAME,
                  value: item.IDSEQ
                }))
              }
              // 处理盘点类型下拉数据
              if (res.result[k].FLDNO === 'OTHTY') {
                this.checkTypeColumns = res2.result.map(item => ({
                  text: item.CNAME,
                  value: item.IDSEQ
                }))
              }
            })
          }
        }
      })
    },

    // 处理数量输入，防止负数
    handleQuantityInput(item) {
      this.isDirty = true
      if (item.NOQTY < 0 || item.NOQTY === '') {
        this.$nextTick(() => {
          item.NOQTY = 0
        })
      }
    },
    // 删除盘点项
    handleDeleteItem(item, index) {
      if (this.isViewMode) {
        return
      }
      this.$dialog.confirm({
        title: '提示',
        message: '确定要删除这条盘点记录吗？'
      }).then(() => {
        this.checkListDel.push(item)
        this.checkList.splice(index, 1)
        this.isDirty = true
        this.$toast.success('删除成功')
      }).catch(() => {})
    },
    // 作废盘点单
    // 作废盘点单
    onVoid() {
      this.$dialog.confirm({
        title: '提示',
        message: '你确定要作废此单据吗？'
      }).then(() => {
        const v_cond = ' set stfg=\'X\' ,chkuser=null,chkdttm=null'

        this.$axios({
          method: 'post',
          url: 'xuper_auth/updateRec',
          data: {
            p_key: 'idseq',
            p_value: this.formData.IDSEQ,
            p_table: 'IC_STK',
            p_cond: v_cond
          }
        }).then(res => {
          if (res.code === '200') {
            this.$toast.success('作废成功')
            this.$router.go(-1)
          } else {
            // 解析错误信息
            const errorMsg = res.result
            const startIndex = errorMsg.indexOf("ORA-20001:")
            const endIndex = errorMsg.indexOf("请核查") + 3

            if (startIndex > 0) {
              const extractedValue = errorMsg.substring(startIndex, endIndex).trim()
              this.$toast.fail(extractedValue)
            } else {
              this.$toast.fail(res.result)
            }
          }
        }).catch(err => {
          console.error('作废失败', err)
          this.$toast.fail('作废失败，请重试')
        })
      }).catch(() => {})
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isDirty && !this.isViewMode) {
      this.$dialog.confirm({
        title: '提示',
        message: '当前有未保存的盘点数据，请先保存或者放弃盘点。确定放弃盘点并退出吗？',
        confirmButtonText: '放弃盘点',
        cancelButtonText: '继续盘点'
      }).then(() => {
        this.isDirty = false
        next()
      }).catch(() => {
        next(false)
      })
    } else {
      next()
    }
  }
}
</script>

<style lang="scss" scoped>
.check-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #F7F8FA;
  overflow: hidden;
}

// 顶部导航栏
.header-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: #F7F8FA;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  z-index: 999;
  flex-shrink: 0;
  overflow: hidden;

  .header-left {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .header-title {
    flex: 1;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    color: #333333;
  }

  .header-right {
    width: 40px;
  }
}

// 信息卡片
.info-section {
  margin-top: 56px;
  padding: 12px;

  .info-card {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 12px 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    .info-row {
      display: flex;
      align-items: center;

      .info-label {
        font-size: 14px;
        line-height: 22px;
        color: #666666;
        min-width: 48px;
        flex-shrink: 0;
      }

      .info-value {
        font-size: 14px;
        line-height: 22px;
        color: #333333;
        margin-right: 16px;
      }
    }
  }
}

// 搜索操作栏
.scan-bar {
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  height: 48px;
  display: flex;
  gap: 8px;
  padding: 8px 12px;
  background: #FFFFFF;
  align-items: center;
  z-index: 998;
  border-bottom: 1px solid #EBEDF0;
  
  .scan-input {
    flex: 1;
  }
}
.check-list {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  padding-bottom: 120px;

  &.check-list-has-scan {
    margin-top: 104px; /* 56px 导航栏 + 48px 扫码栏 */
  }

  &.check-list-view-mode {
    margin-top: 56px; /* 56px 导航栏 */
  }

  .empty-state {
    padding: 60px 0;
  }

  .list-content {
    .check-item-card {
      background: #FFFFFF;
      border-radius: 8px;
      padding:2px 12px;
      margin-bottom: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

      .item-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 2px;
        padding-bottom: 2px;
        border-bottom: 1px solid #F0F0F0;

        .item-no {
          width: 24px;
          height: 24px;
          background: #235EFF;
          color: #FFFFFF;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-weight: 600;
          flex-shrink: 0;
        }

        .item-code {
          font-size: 16px;
          font-weight: 600;
          line-height: 26px;
          color: #333333;
          flex: 1;
        }
      }

      .item-content {
        display: flex;
        justify-content: space-between;
        gap: 12px;

        .item-info {
          flex: 1;
          min-width: 0;

          .item-name {
            font-size: 14px;
            line-height: 22px;
            color: #333333;
            margin-bottom: 4px;
          }

          .item-spec {
            font-size: 12px;
            line-height: 20px;
            color: #999999;
          }
        }

        .item-quantity {
          flex-shrink: 0;

          .quantity-row {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 4px;

            &:last-child {
              margin-bottom: 0;
            }

            .quantity-label {
              font-size: 12px;
              line-height: 20px;
              color: #666666;
              min-width: 48px;
            }

            .quantity-value {
              width: 80px;
              font-size: 14px;
              line-height: 22px;
              color: #333333;
              font-weight: 500;
              text-align: right;
              &.highlight {
                color: #235EFF;
              }
            }

            .quantity-input {
              width: 80px;
              padding: 0;
              background: transparent;
              border-radius: 4px;
              font-size: 14px;
              line-height: 20px;
              min-height: 20px;
              height: 20px;

              ::v-deep .van-cell {
                padding: 0;
                background: transparent;
                line-height: 20px;
              }

              ::v-deep .van-field__body {
                height: 20px;
              }

              ::v-deep .van-field__control {
                color: #235EFF;
                font-size: 14px;
                line-height: 20px;
                font-weight: 500;
                text-align: right;
                padding: 0 8px;
                height: 20px;
                background: #F7F8FA;
                border-radius: 4px;

                &::placeholder {
                  color: #999999;
                  font-size: 12px;
                }
              }
            }
          }
        }
      }
    }
  }
}

// 底部操作栏
.footer-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #FFFFFF;
  border-top: 1px solid #EBEDF0;
  padding: 4px 16px;
  z-index: 100;

  .footer-stats {
    font-size: 14px;
    line-height: 22px;
    color: #666666;
    margin-bottom: 4px;
    .stats-count {
      color: #235EFF;
      font-weight: 600;
    }
  }

  .footer-actions {
    display: flex;
    gap: 12px;

    .footer-btn {
      flex: 1;
      width: 100px;
      height: 48px;
      border: none;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 500;

      &.footer-btn-cancel {
        background: #F0F0F0 !important;
        color: #666666 !important;

        &:active {
          background: #E0E0E0 !important;
        }
      }

      &.footer-btn-submit {
        background: #235EFF !important;
        color: #FFFFFF !important;

        &:active {
          background: #103B9A !important;
        }
      }

      &.footer-btn-void {
        background: #FF4000 !important;
        color: #FFFFFF !important;

        &:active {
          background: #CC3300 !important;
        }
      }
    }
  }
}

/* 盘点卡片中的打印入口与删除图标同级，居中并缩小为紧凑按钮。 */
.check-item-card ::v-deep .material-label-print {
  display: flex;
  justify-content: center;
  margin: 0 8px 0 auto;
}
.check-item-card ::v-deep .material-print-actions {
  justify-content: center;
  margin: 0;
  padding: 0;
  border: 0;
}
.check-item-card ::v-deep .material-print-button {
  min-width: 30px;
  width: 30px;
  height: 30px;
  padding: 0;
  font-size: 13px;
  line-height: 28px;
}
.check-item-card .item-header {
  position: relative;
  display: flex;
  align-items: center;
}
.check-item-card .item-header ::v-deep .material-label-print {
  position: absolute;
  left: 50%;
  margin: 0;
  transform: translateX(-50%);
}

// 物料选择弹窗
.select-dialog {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;

  .dialog-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border-bottom: 1px solid #EBEDF0;

    .dialog-title {
      font-size: 18px;
      font-weight: 600;
      line-height: 28px;
      color: #333333;
    }
    
    .van-icon {
      cursor: pointer;
      color: #333333;
      
      &:active {
        opacity: 0.6;
      }
    }
  }

  .dialog-search {
    padding: 12px 16px;
    background: #F7F8FA;

    ::v-deep .van-field {
      background: #FFFFFF;
      border-radius: 8px;
      padding: 10px 12px;
      border: 1px solid #E5E5E5;

      .van-field__left-icon {
        color: #999999;
        margin-right: 8px;
      }

      .van-field__control {
        font-size: 14px;
        line-height: 22px;
        color: #333333;

        &::placeholder {
          color: #999999;
        }
      }
    }
  }

  .dialog-list {
    flex: 1;
    overflow-y: auto;
    padding: 12px 16px;
    background: #F7F8FA;

    .material-item {
      padding: 12px 16px;
      background: #FFFFFF;
      border-radius: 8px;
      margin-bottom: 12px;
      cursor: pointer;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      transition: all 0.2s;

      &:active {
        background: #F7F8FA;
        transform: scale(0.98);
      }

      .material-code {
        font-size: 16px;
        font-weight: 600;
        line-height: 26px;
        color: #333333;
        margin-bottom: 6px;
      }

      .material-name {
        font-size: 14px;
        line-height: 22px;
        color: #333333;
        margin-bottom: 4px;
      }

      .material-spec {
        font-size: 12px;
        line-height: 20px;
        color: #999999;
      }
    }
  }
}

// 数量输入弹窗
::v-deep .quantity-dialog {
  width: 90% !important;
  max-width: 400px;
  border-radius: 12px;

  .van-dialog__header {
    padding: 16px;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    line-height: 28px;
  }

  .van-dialog__content {
    padding: 0;
  }

  .van-dialog__footer {
    display: flex;
    justify-content: center;
    gap: 12px;
    padding: 16px;

    .van-button {
      width: 100px !important;
      min-width: 100px !important;
      max-width: 100px !important;
      height: 40px;
      font-size: 14px;
      border: none;
      border-radius: 8px;
      flex: none;

      &--default {
        background: #AAAAAA;
        color: #FFFFFF;

        &:active {
          background: #8C8C8C;
        }
      }

      &--primary {
        background: #235EFF;
        color: #FFFFFF;

        &:active {
          background: #103B9A;
        }
      }
    }
  }
}

.quantity-form {
  padding: 16px;

  .form-row {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    &.form-row-input {
      align-items: flex-start;
      flex-direction: column;
      gap: 8px;
    }

    .form-label {
      font-size: 14px;
      line-height: 22px;
      color: #333333;
      font-weight: 500;
      min-width: 80px;
      &.required::before {
        content: '*';
        color: #FF4000;
        margin-right: 2px;
      }
    }

    .form-value {
      font-size: 14px;
      line-height: 22px;
      color: #666666;
      flex: 1;
    }

    .quantity-input {
      width: 100%;
      height: 48px;
      border: 1px solid #D9D9D9;
      border-radius: 8px;
      font-size: 14px;
      padding: 0 12px;
      color: #333333;
      background: #FFFFFF;

      &:focus {
        border-color: #235EFF;
        outline: none;
      }

      &::placeholder {
        color: #999999;
      }
    }
  }
}

// 表单样式
.add-form {
  margin-top: 56px;
  padding: 12px;
  background: #FFFFFF;
  flex-shrink: 0;
  overflow: visible;
  
  .form-row-group {
    display: flex;
    gap: 12px;
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .form-item-col {
    flex: 1;
    min-width: 0;

    &.form-item-full {
      flex: 1 1 100%;
    }

    .form-label {
      display: block;
      font-size: 13px;
      color: #333333;
      font-weight: 500;
      line-height: 20px;

      .required {
        color: #FF4000;
        margin-right: 2px;
      }
    }
  }
}

::v-deep .van-field {
  padding: 8px 12px;
  background: #F7F8FA;
  border-radius: 8px;
  font-size: 13px;
  line-height: 20px;
  min-height: 32px;

  .van-field__control {
    color: #333333;
    font-size: 13px;
    line-height: 20px;
    text-align: left;

    &::placeholder {
      color: #999999;
      text-align: left;
    }

    &:disabled {
      color: #999999;
      -webkit-text-fill-color: #999999;
    }
  }

  &--disabled {
    .van-field__control {
      background: #F7F8FA;
    }
  }

  .van-field__word-limit {
    color: #999999;
    font-size: 12px;
    line-height: 20px;
    margin-top: 2px;
  }
}

::v-deep .van-picker {
  .van-picker__toolbar {
    height: 48px;
    padding: 0 16px;

    .van-picker__cancel {
      font-size: 16px;
      color: #666666;
    }

    .van-picker__confirm {
      font-size: 16px;
      color: #235EFF;
    }

    .van-picker__title {
      font-size: 18px;
      font-weight: 600;
      color: #333333;
      line-height: 28px;
    }
  }

  .van-picker__columns {
    font-size: 16px;
  }
}

::v-deep .van-datetime-picker {
  .van-picker__toolbar {
    height: 48px;
    padding: 0 16px;

    .van-picker__cancel {
      font-size: 16px;
      color: #666666;
    }

    .van-picker__confirm {
      font-size: 16px;
      color: #235EFF;
    }

    .van-picker__title {
      font-size: 18px;
      font-weight: 600;
      color: #333333;
      line-height: 28px;
    }
  }

  .van-picker__columns {
    font-size: 16px;
  }
}

// 强制覆盖 van-button 默认样式
::v-deep .footer-btn.van-button {
  border: none !important;
  
  &.footer-btn-cancel {
    background: #F0F0F0 !important;
    
    .van-button__text {
      color: #666666 !important;
    }
  }
  
  &.footer-btn-submit {
    background: #235EFF !important;
    
    .van-button__text {
      color: #FFFFFF !important;
    }
  }
  
  &.footer-btn-void {
    background: #FF4000 !important;
    
    .van-button__text {
      color: #FFFFFF !important;
    }
  }
}

</style>
